import { graphql } from 'gql/generated/gql'

export const UPSERT_PARTNER_COSTS = graphql(`
  mutation UpsertPartnerCosts($input: UpsertPartnerCostsInput!) {
    upsertPartnerCosts(input: $input)
  }
`)
